import React, { Component } from 'react';
import { Table } from 'react-bootstrap';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { hideModal, showModal } from '../../actions/ModalActions';
import * as actions from '../../actions/ProductActions'
import ModalRoot from '../Modal/ModalRoot';
import Pagination from './Pagination'
import './style.css'
import ClipLoader from "react-spinners/ClipLoader";
const btnStyle = {
    background: "0 0",
    textAlign: 'left',
    color: '#333'
}
const btnItem = {
    display: 'block',
}
const override = {
    display: 'block',
    margin: '0 auto',
    borderColor: 'red',
}

class Products extends Component {

    constructor(props) {
        super(props);
        this.state = {
            textSearch: '',
            filterName: '',
            filterCategory: '',
            filterPrice: '',
            currentPage: 1,
            postPerPage: 5,
            pageNumber: 1,
        }
    }

    componentDidMount() {
        this.props.getAllProduct();
    }



    closeModal = () => {
        this.props.hideModal();
    }

    openModalDelete = (product) => {
        this.props.showModal({
            open: true,
            closeModal: this.closeModal,
            product: product
        }, 'alert')
    }

    // convert date
    convert = (str) => {
        var date = new Date(str),
            mnth = ("0" + (date.getMonth() + 1)).slice(-2),
            day = ("0" + date.getDate()).slice(-2);
        return [day, mnth, date.getFullYear()].join("-");
    }
    // format price
    format_curency = ((money) => {
        money = money.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
        return money + "₫";
    });

    // onchange input
    handleChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        })
    }

    // filter theo tung gia tri name || price || category
    handleFilter = (e) => {
        let target = e.target;
        let name = target.name;
        let value = target.value;
        let filter = {
            filterName: name === "filterName" ? value : this.state.filterName,
            filterCategory: name === "filterCategory" ? value : this.state.filterCategory,
            filterPrice: name === "filterPrice" ? value : this.state.filterPrice,
        }
        this.props.filterValue(filter)
        this.setState({
            [name]: value
        })
    }

    handleSort = ({ sortBy, sortValue }) => {
        this.props.sortProducts({ sortBy, sortValue })
    }

    showListProduct = (products) => {
        if (products) {
            return products.map((item, index) => {
                var date = item.createAt;
                var dateTime = this.convert(new Date(date).toString())
                var category = item.category;
                switch (category) {
                    case 'ao':
                        category = "Áo"
                        break;
                    case 'ao-khoac':
                        category = "Áo khoác"
                        break;
                    case 'quan':
                        category = "Quần"
                        break;
                    case 'vay-dam':
                        category = "Váy đầm"
                        break;
                    case 'bo-mac-nha':
                        category = "Bộ mặc nhà"
                        break;
                    case 'tui-xach':
                        category = "Túi xách"
                        break;
                    case 'giay':
                        category = "Giày"
                        break;
                    default:
                        category = "";
                        break;
                }
                return (
                    <tr key={index}>
                        <td>{index + 1}</td>
                        <td>{item.name}</td>
                        <td>{item.sku}</td>
                        <td style={{ textAlign: 'center' }}>{category}</td>
                        <td>{this.format_curency(item.price)}</td>
                        <td>{dateTime}</td>
                        <td>{item.material}</td>
                        <td>
                            <Link to={`/products/${item.id}`} className="btn btn-outline-success mr-2">Detail</Link>
                            <Link to={`/product/${item.id}/edit`} className="btn btn-outline-info mr-2">Edit</Link>
                            <button
                                className="btn btn-outline-warning"
                                onClick={() => this.openModalDelete(item)}
                            >Delete</button>
                        </td>
                    </tr>
                )
            })
        }
    }

    render() {
        var { isFetching, products, totalProduct, filterName, filterCategory, filterPrice, sortBy, sortValue } = this.props;
        // eslint-disable-next-line no-self-assign
        var result = null;

        var { currentPage, postPerPage } = this.state;
        const indexOfLastPost = currentPage * postPerPage;
        const indexOfFirstPost = indexOfLastPost - postPerPage;
        const currentPost = products.slice(indexOfFirstPost, indexOfLastPost)
        const paginate = pageNumber => {
            this.setState({
                currentPage: pageNumber
            })
        }


        // Filter
        if (filterName) {
            products = products.filter(product => {
                return product.name.toLowerCase().indexOf(filterName.toLowerCase()) !== -1
            })
        } else if (filterCategory) {
            if (filterCategory === 'default') {
                // eslint-disable-next-line no-self-assign
                products = products;
            } else {
                products = products.filter(product => {
                    return product.category.toLowerCase().indexOf(filterCategory.toLowerCase()) !== -1
                })
            }
        } else if (filterPrice) {
            products = products.filter(product => {
                return product.price.toString().indexOf(filterPrice) !== -1
            })
        }

        // Sort 
        if (sortBy === 'name') {
            products = products.sort((a, b) => {
                if (a.name > b.name) return sortValue;
                else if (a.name < b.name) return - sortValue;
                else return 0
            })
        } else if (sortBy === 'price') {
            products = products.sort((a, b) => {
                if (a.price > b.price) return sortValue;
                else if (a.price < b.price) return - sortValue;
                else return 0
            })
        }

        if (isFetching) {
            return <ClipLoader
                size={150}
                color={"#123abc"}
                css={override}
                loading={isFetching}
            />
        } else {
            return (
                <div className="products__page pt-2 pb-4">
                    {result}
                    <div className="container">
                        <div className="row">
                            <div className="col-12">
                                <h3 className="account__page--title">Products</h3>
                            </div>
                            <div className="col-12 pt-3 pb-3 d-flex justify-content-between align-items-center">
                                <Link to="/product/add"
                                    className="btn btn-outline-danger"
                                >Add Product
                            </Link>
                                <div className="d-flex justify-content-between align-items-center">
                                    <input
                                        type="text"
                                        style={{ width: '300px' }}
                                        placeholder="Search"
                                        className="form-control"
                                        name="textSearch"
                                        value={this.state.textSearch}
                                        onChange={this.handleChange}
                                    />
                                    <button
                                        className="btn btn-outline-danger ml-3"
                                        onClick={() => {
                                            this.props.searchProducts(this.state.textSearch)
                                        }}
                                    >Search
                            </button>
                                </div>
                                <div className="main__content--heading-sort d-flex align-items-center">
                                    <span>Sắp xếp theo: </span>
                                    <div className="dropdown">
                                        <button
                                            style={btnStyle}
                                            className="btn btn-outline-danger dropdown-toggle btn-sort"
                                            type="button" id="dropdownMenuButton"
                                            data-toggle="dropdown"
                                            aria-haspopup="true"
                                            aria-expanded="false"
                                        >Mặc định</button>
                                        <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                            <button
                                                style={btnItem}
                                                className="dropdown-item"
                                                onClick={() => {
                                                    this.handleSort({ sortBy: 'price', sortValue: 1 })
                                                }}
                                            >Giá: Giảm dần</button>
                                            <button
                                                style={btnItem}
                                                className="dropdown-item"
                                                onClick={() => {
                                                    this.handleSort({ sortBy: 'price', sortValue: -1 })
                                                }}
                                            >Giá: Tăng dần</button>
                                            <button
                                                style={btnItem}
                                                className="dropdown-item"
                                                onClick={() => {
                                                    this.handleSort({ sortBy: 'name', sortValue: 1 })
                                                }}
                                            >Tên: A-Z</button>
                                            <button
                                                style={btnItem}
                                                className="dropdown-item"
                                                onClick={() => {
                                                    this.handleSort({ sortBy: 'name', sortValue: -1 })
                                                }}
                                            >Tên: Z-A</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-12">
                                <Table striped bordered hover>
                                    <thead>
                                        <tr>
                                            <th>STT</th>
                                            <th>
                                                Name
                                            <input
                                                    type="text"
                                                    placeholder="Name"
                                                    className="form-control"
                                                    name="filterName"
                                                    onChange={this.handleFilter}
                                                />
                                            </th>
                                            <th style={{ width: '100px' }}>
                                                SKU
                                        </th>
                                            <th style={{ width: '100px' }}>
                                                Category
                                            <select
                                                    id="inputState"
                                                    className="form-control"
                                                    name="filterCategory"
                                                    value={this.state.filterCategory}
                                                    onChange={this.handleFilter}
                                                >
                                                    <option value="default">Mặc định</option>
                                                    <option defaultValue="ao" value="ao">Áo</option>
                                                    <option value="ao-khoac">Áo khoác</option>
                                                    <option value="quan">Quần</option>
                                                    <option value="giay">Giày</option>
                                                    <option value="vay-dam">Váy đầm</option>
                                                    <option value="tui-xach">Túi xách</option>
                                                    <option value="bo-mac-nha">Bộ mặc nhà</option>
                                                </select>
                                            </th>
                                            <th style={{ width: '100px' }}>
                                                Price
                                            <input
                                                    type="text"
                                                    placeholder="Price"
                                                    className="form-control"
                                                    name="filterPrice"
                                                    onChange={this.handleFilter}
                                                />
                                            </th>
                                            <th style={{ width: '100px' }}>Date</th>
                                            <th style={{ width: '15%' }}>
                                                Material
                                        </th>
                                            <th>Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.showListProduct(currentPost)}
                                    </tbody>
                                </Table>
                                <Pagination
                                    totalProduct={totalProduct}
                                    postPerPage={postPerPage}
                                    currentPage={currentPage}
                                    paginate={paginate}
                                />
                            </div>
                        </div>
                    </div>
                    <ModalRoot hideModal={this.props.hideModal} />
                </div>
            );
        }
    }
}

const mapStateToProps = (state) => {
    return {
        isFetching: state.products.isFetching,
        products: state.products.listProduct,
        totalProduct: state.products.totalProduct,
        ...state.modal,
        filterName: state.products.filterName,
        filterCategory: state.products.filterCategory,
        filterPrice: state.products.filterPrice,
        sortValue: state.products.sortValue,
        sortBy: state.products.sortBy
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        getAllProduct: () => {
            dispatch(actions.fetchAPIALLProduct())
        },
        showModal: (modalProps, modalType) => {
            dispatch(showModal({ modalProps, modalType }))
        },
        hideModal: () => {
            dispatch(hideModal())
        },
        searchProducts: (textSearch) => {
            dispatch(actions.fetchAPISearchProduct(textSearch))
        },
        filterValue: (filter) => {
            dispatch(actions.filterValue(filter))
        },
        sortProducts: (sort) => {
            dispatch(actions.sortProducts(sort))
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Products);
